import React, { Component } from "react";
import Chart from "./components/Chart";
import { GetAnalyticFilter } from "Store";
import { observer } from "mobx-react";
import { queryGetTotalCategoryCount } from "Apollo";
import { graphql } from "react-apollo";
import EmptyPanel from "./components/EmptyPanel";

const gqlOptions = {
  options: {
    fetchPolicy: "network-only"
  }
};

const Box = graphql(queryGetTotalCategoryCount, gqlOptions)(
  class WordCloud extends Component {
    render() {
      const {
        data: { loading, getTotalCategoryCount }
      } = this.props;
      let series = [];
      if (!loading && getTotalCategoryCount) {
        series = getTotalCategoryCount.data;
      }
      const opt = {
        chartType: "pie",
        title: "Category",
        series
      };

      if (series[0]) {
        return <Chart {...opt} />;
      } else {
        return <EmptyPanel />;
      }
    }
  }
);

export default observer(
  class BoxWithQuery extends Component {
    render() {
      return <Box {...GetAnalyticFilter()} />;
    }
  }
);



// WEBPACK FOOTER //
// ./src/module-analytics/Category.js